module.exports = __webpack_public_path__ + "img/info-circle-light.e0bc0776.svg";